var _line, _path, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDivider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 368,
    height: 20,
    viewBox: "0 0 368 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 9.5,
    x2: 132.5,
    y2: 9.5,
    stroke: "#BBBBBC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.924 15.126C180.205 15.126 179.552 14.9627 178.964 14.636C178.385 14.3093 177.928 13.8473 177.592 13.25C177.265 12.6433 177.102 11.9433 177.102 11.15C177.102 10.366 177.27 9.67533 177.606 9.078C177.951 8.47133 178.418 8.00933 179.006 7.692C179.594 7.36533 180.252 7.202 180.98 7.202C181.708 7.202 182.366 7.36533 182.954 7.692C183.542 8.00933 184.004 8.46667 184.34 9.064C184.685 9.66133 184.858 10.3567 184.858 11.15C184.858 11.9433 184.681 12.6433 184.326 13.25C183.981 13.8473 183.509 14.3093 182.912 14.636C182.315 14.9627 181.652 15.126 180.924 15.126ZM180.924 14.006C181.381 14.006 181.811 13.8987 182.212 13.684C182.613 13.4693 182.935 13.1473 183.178 12.718C183.43 12.2887 183.556 11.766 183.556 11.15C183.556 10.534 183.435 10.0113 183.192 9.582C182.949 9.15267 182.632 8.83533 182.24 8.63C181.848 8.41533 181.423 8.308 180.966 8.308C180.499 8.308 180.07 8.41533 179.678 8.63C179.295 8.83533 178.987 9.15267 178.754 9.582C178.521 10.0113 178.404 10.534 178.404 11.15C178.404 11.7753 178.516 12.3027 178.74 12.732C178.973 13.1613 179.281 13.4833 179.664 13.698C180.047 13.9033 180.467 14.006 180.924 14.006ZM187.807 8.574C188.031 8.13533 188.348 7.79467 188.759 7.552C189.179 7.30933 189.688 7.188 190.285 7.188V8.504H189.949C188.521 8.504 187.807 9.27867 187.807 10.828V15H186.533V7.328H187.807V8.574Z",
    fill: "#8F8F92"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 235.5,
    y1: 9.5,
    x2: 368,
    y2: 9.5,
    stroke: "#BBBBBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/divider.bf096d747bcc69217516faf9edfa393c.svg";
export { ForwardRef as ReactComponent };